export default __webpack_public_path__ + "static/media/banner2.86ee1c12.svg";